<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/xin-c.png" class="customers customer1" v-if="status==1">
            <img src="../../../assets/images/xin-biao.png" class="customers customer2" v-if="status==2">
            <img src="../../../assets/images/xin-back.png" class="customers customer3" v-if="status==3">
            <img src="../../../assets/images/xin-jilu.png" class="customers customer4" v-if="status==4">
            <img src="../../../assets/images/xin-chakan.png" class="customers customer5" v-if="status==5">
            <div class="customerbtn" @click="nextcustomer(status)">
                {{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--<breadcrumb :routerList="[{to:'/credit',title:'经理销售维度'},{title:'客户详情'}]"/>-->
      <Breadtabsheader/>
      <div class="w-span" style="margin:20px">
            <div class="h-row h-mrt0" style="margin:0 -0.12rem ;">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="data" label-position="right" ref="zy" :inline="true"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine">
                                            <el-form-item label="客户名称" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="data.username"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <!--								   <el-form-item label="货方控制范围" class="h-elformWrap-2" >-->
                                            <!--										<el-input placeholder="请输入" v-model="data.kkber" readonly="true"></el-input>-->
                                            <!--									   <template slot-scope="scope">-->
                                            <!--										   <dictname category="kkber_value" :v="data.kkber"/>-->
                                            <!--									   </template>-->
                                            <!--								   </el-form-item>-->
                                            <!--								   <el-form-item label="客户信贷银行" class="h-elformWrap-2">-->
                                            <!--										<el-input placeholder="请输入" v-model="data.creCategory" readonly="true"></el-input>-->
                                            <!--								   </el-form-item>-->
                                            <!--								   <el-form-item label="币种" class="h-elformWrap-2" >-->
                                            <!--										<el-input placeholder="请输入" v-model="data.currencyCode" readonly="true"></el-input>-->
                                            <!--									   <template slot-scope="scope">-->
                                            <!--										   <dictname category="kkber_value" :v="data.kkber"/>-->
                                            <!--									   </template>-->
                                            <!--								   </el-form-item>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0">
                                        <h1>数据图表</h1>
                                    </div>
                                    <div class="h-rowCon" style="padding-top: 0;">
                                        <div class="h-funnelChart">
                                            <div class="h-funnelChartIn"
                                                 style="display:flex;width:100%;margin:0;height:250px;">
                                                <div class="h-pieChart" id="h_lineChart1"
                                                     style="width: 33%; height: 100%;"></div>
                                                <div class="h-pieChart" id="h_lineChart2"
                                                     style="width: 33%; height: 100%;"></div>
                                                <div class="h-pieChart" id="h_lineChart3"
                                                     style="width: 33%; height: 100%;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-- 新增的信贷调配 -->
            <div class="h-row" style="margin:0 -0.12rem;margin-top: 0.3rem;" v-if="isShowTiaoPei">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                                :model="queryCreditTiaoPei"
                                label-position="right"
                                ref="queryCreditTiaoPei"
                                :inline="true"
                                :rules="rules1"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>信贷调配</h1>
                                    </div>
                                    <div style="margin: 0.4rem 0 0 0.2rem;" class="weekplandetail26">
                                        <el-form-item label="需要调配的信贷" class="h-elformWrap-2" style="widht:100%">
                                            <el-select v-model="creditId" placeholder="请选择" @change="chooseCredit">
                                                <el-option
                                                        v-for="item in tableData4"
                                                        :key="item.id"
                                                        :label="item.id"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="h-pieceCon2" v-show="value != ''">
                                        <div class="h-formLine weekplandetail26">
                                            <el-form-item label="信贷编号" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.id"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="可用信贷额度" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.quota"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="最大信贷额度" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.maxquota"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="有效期截止日期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.validitydate"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷账期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.paymentdate"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷类型" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.creCategory"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="value.creCategory" category="cre_category" :v="value.creCategory"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2"
                                                          v-show="value.creCategory == '0'">
                                                <el-input placeholder="" v-model="value.productId"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="value.productId" category="product_level" :v="value.productId"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="公司代码" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.kkber"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="value.kkber" category="kkber_value" :v="value.kkber"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>

                                        </div>
                                    </div>

                                    <div style="margin: 0.4rem 0 0 0.2rem;" class="weekplandetail26" v-show="value != ''">
                                        <el-form-item label="调配至公司代码" class="h-elformWrap-2"
                                                      style="margin-bottom: 0.4rem;" prop="kkber">
                                            <brselect category="kkber_value" :v="queryCreditTiaoPei.kkber"
                                                      v-model="queryCreditTiaoPei.kkber" :clearable="true"
                                                      @change="queryByTiaoPeiCredit"
                                                      />
                                        </el-form-item>
                                        <el-form-item label="调配至产品大类" class="h-elformWrap-2"
                                                      style="margin-bottom: 0.4rem;" v-if="value.creCategory == '0'"
                                                      prop="productId">
                                            <brselect category="product_level" :v="queryCreditTiaoPei.productId"
                                                      v-model="queryCreditTiaoPei.productId" :clearable="true"
                                                      @change="queryByTiaoPeiCredit"
                                                      />
                                        </el-form-item>
                                        <el-form-item label="" class="h-elformWrap-2" style="margin-bottom: 0.4rem;">
                                            <el-switch
                                                    @change="chooseByCredit"
                                                    v-model="isSelfTiaoPei"
                                                    active-text="自身调配"
                                                    inactive-text="">
                                            </el-switch>
                                        </el-form-item>
                                        <el-form-item label="可被调配的信贷" class="h-elformWrap-2"
                                                      style="margin-bottom: 0.4rem;" v-if="isshowByTiaoPeiCredit()" prop="value1">
                                            <el-select v-model="creditId2" placeholder="请选择"  @change="chooseByCredit">
                                                <el-option

                                                        v-for="item in options"
                                                        :key="item.id"
                                                        :label="item.id"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                    </div>
                                    <!--							自身调配时展示-->
                                    <div class="h-pieceCon2" v-if="isSelfTiaoPei">
                                        <div class="h-formLine weekplandetail26">
                                            <el-form-item label="信贷编号" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.id"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="调配信贷额度" class="h-elformWrap-2" prop="maxquota">
                                                <el-input placeholder="请输入" v-model="queryCreditTiaoPei.maxquota"
                                                          @keyup.native="changeCreditBalance" ref="ref1"></el-input>
                                            </el-form-item>
                                            <!--									<el-form-item label="最大信贷额度" class="h-elformWrap-2">-->
                                            <!--										<el-input placeholder="请输入" v-model="queryCreditTiaoPei.maxquota" readonly="true"></el-input>-->
                                            <!--									</el-form-item>-->
                                            <el-form-item label="有效期截止日期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.validitydate"
                                                          ></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷账期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.paymentdate"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷类型" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value.creCategory"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="value.creCategory" category="cre_category" :v="value.creCategory"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="调配至产品大类" class="h-elformWrap-2"
                                                          v-show="value.creCategory == '0'">
                                                <el-input placeholder="" v-model="queryCreditTiaoPei.productId"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="queryCreditTiaoPei.productId" category="product_level1"
                                                              :v="queryCreditTiaoPei.productId"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="调配至公司代码" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="queryCreditTiaoPei.kkber"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="queryCreditTiaoPei.kkber" category="kkber_value" :v="queryCreditTiaoPei.kkber?queryCreditTiaoPei.kkber:' '"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <!--							不自身调配时展示-->
                                    <div class="h-pieceCon2" v-if="!isSelfTiaoPei&&value1 != ''">
                                        <div class="h-formLine weekplandetail26">
                                            <el-form-item label="信贷编号" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value1.id"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="调配信贷额度" class="h-elformWrap-2" prop="maxquota">
                                                <el-input placeholder="请输入" v-model="queryCreditTiaoPei.maxquota"
                                                          @keyup.native="changeCreditBalance" ref="ref1"></el-input>
                                            </el-form-item>
                                            <el-form-item label="现有信贷额度" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value1.quota"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="有效期截止日期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value1.validitydate"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷账期" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value1.paymentdate"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷类型" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="value1.creCategory"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="value1.creCategory" category="cre_category" :v="value1.creCategory"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="调配至产品大类" class="h-elformWrap-2"
                                                          v-show="value.creCategory == '0'">
                                                <el-input placeholder="" v-model="queryCreditTiaoPei.productId"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="queryCreditTiaoPei.productId" category="product_level1"
                                                              :v="queryCreditTiaoPei.productId"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="调配至公司代码" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="queryCreditTiaoPei.kkber"
                                                          readonly></el-input>
                                                <template slot-scope="scope">
                                                    <div style="color: #868686;border-bottom: 1px solid #dedede;font-size: 0.16rem;">
														<dictname v-if="queryCreditTiaoPei.kkber" category="kkber_value" :v="queryCreditTiaoPei.kkber"/>
														<span v-else>&nbsp;</span>
													</div>
                                                </template>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div style="text-align: center" v-show="value != '' ">
                                    <el-button class="h-btn h-bBtn" type="primary"
                                               @click="tiaoPeiCredit('queryCreditTiaoPei')">确认调配
                                    </el-button>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-piece h-mrt30" style="padding-bottom: 1px;">
                <div class="outerCon">
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">回款详情</div>
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '2'}" @click="tabchange(2)">客户明细帐单数据</div>
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">信贷记录</div>
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '4'}" @click="tabchange(4)" v-show="companyCode != '0PN0' && companyCode != '1R60'">对账记录</div>
                </div>
            </div>
            <div class="h-table" style="margin-top: 0.2rem;">
                <!--		  客户内销回款详情列表-->
                <div style="font-size: 14px;color: #ff0000" v-if="tabIndex == '1' && countrytype == '1'">
                    ※功能介绍：该报表显示自2020年1月1日至今贵司的入账明细 <br>
                    ※查询路径：信贷管理-资金详情-查看-回款详情（凭证类型DZ表示贵司电汇付款入账金额，RV表示返利兑现入账金额，如果遇到其他特殊类型文本有具体说明或者咨询我司财务人员）
                </div>
                <div style="font-size: 14px;color: #ff0000" v-else-if="tabIndex == '1' && countrytype == '2'"  >
                    ※功能介绍：该报表显示自我司sap上线后的明细账，具体可查看自2015年11月1日后的明细账 <br>
                    ※查询路径：信贷管理-资金详情-查看-客户明细账数据（请先同步历史明细后，导出明细帐进行核对）
                </div>
                <div style="font-size: 14px;color: #ff0000" v-else-if="tabIndex == '2'"  >
                    ※功能介绍：该报表显示自我司sap上线后的明细账，具体可查看自2015年11月1日后的明细账 <br>
                    ※查询路径：信贷管理-资金详情-查看-客户明细账数据（请先同步历史明细后，导出明细帐进行核对）
                </div>
                <div style="font-size: 14px;color: #ff0000" v-else-if="tabIndex == '3'">
                    ※功能介绍：该报表展示自销售平台上线后走系统申请的所有信贷记录，可以查询每笔信贷的审批情况及到期还款情况 <br>
                    ※查询路径：信贷管理-资金详情-查看-信贷记录
                </div>
                <el-table
                        v-if="tabIndex == '1' && countrytype == '1'"
                        ref="multipleTable"
                        :data="tableData"
                        stripe
                        style="width: 100%"
						:border="true"
						max-height="450"
                >
                    <el-table-column type="selection" width="45" label="全选"></el-table-column>
                    <el-table-column fixed type="index" label="#" width="40"></el-table-column>
                    <el-table-column prop="belnr" label="凭证编号" width="150" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="wrbtr" label="金额" width="80"
						 :show-overflow-tooltip="true">
						 <template slot-scope="scope">
							 <div style="text-align: right;">
								 {{scope.row.wrbtr}}
							 </div>
						 </template>
					 </el-table-column>
                    <el-table-column prop="blart" label="凭证类型" width="90" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="bukrs" label="公司代码" width="90" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="waers" label="货币类型" min-width="80"
                                     :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="budat" label="凭证过账日期" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="gjahr" label="会计年度" min-width="80" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="sgtxt" label="文本" min-width="150" :show-overflow-tooltip="true"></el-table-column>
<!--                    <el-table-column label="操作" fixed="right" width="80">
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="seeDetail(scope.row)"
                            >查看
                            </el-button>
							&lt;!&ndash; <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="seeDetail(scope.row)"></span>
							</div> &ndash;&gt;
                        </template>
                    </el-table-column>-->
                </el-table>
                <!--		  客户外销回款详情列表-->
                <el-table
                        v-if="tabIndex == '1' && countrytype == '2'"
                        ref="multipleTable"
                        :data="tableData1"
                        stripe
                        style="width: 100%"
						:border="true"
						max-height="450"
                >
                    <el-table-column type="selection" width="45" label="全选" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column fixed type="index" label="#" width="40" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="remitterName" label="汇款人名称" width="110" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="receCertNumber" label="凭证编号" width="200" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="receBank" label="回款银行" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="receMark" label="回款标识" min-width="100" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="credit_type" :v="scope.row.receMark"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="receAmount" label="银行入账金额" min-width="120" :show-overflow-tooltip="true">
						<template slot-scope="scope">
						    <div style="text-align: right;">
						        {{scope.row.receAmount}}
						    </div>
						</template>
					</el-table-column>
                    <el-table-column prop="receDate" label="银行入账日期" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="80">
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="seeDetail(scope.row)"
                            >查看
                            </el-button>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="seeDetail(scope.row)"></span>
							</div> -->
                        </template>
                    </el-table-column>
                </el-table>
				<!--		  客户全部明细账单数据列表-->
				<el-table
				        v-show="tabIndex == '2'"
				        ref="multipleTable"
				        :data="tableData2"
				        stripe
				        style="width: 100%"
						:border="true"
						max-height="450"
				>
					<el-table-column type="selection" width="55" label="全选"></el-table-column>
					<el-table-column type="index" width="40" label="#" fixed></el-table-column>
					<el-table-column prop="belnr" label="会计凭证编号" width="120"></el-table-column>
					<el-table-column prop="bukrs" label="公司代码" width="80"></el-table-column>
					<el-table-column prop="kunnr" label="客户编号" width="120"></el-table-column>
					<!-- <el-table-column prop="name1" label="名称" width="220"></el-table-column> -->
					<el-table-column prop="gjahr" label="会计年度" width="60"></el-table-column>
					<el-table-column prop="blart" label="凭证类型" width="60"></el-table-column>
					<el-table-column prop="budat" label="凭证中的过帐日期" width="150"></el-table-column>
					<el-table-column prop="pswbt" label="总帐中更新的金额" width="150"></el-table-column>
					<el-table-column prop="waers" label="货币码" width="80"></el-table-column>
					<el-table-column prop="dmbtr" label="按本位币计的金额" width="150"></el-table-column>
					<el-table-column prop="waerb" label="货币码" width="80"></el-table-column>
					<el-table-column prop="sgtxt" label="项目文本" width="250"></el-table-column>
					<el-table-column prop="zuonr" label="分配编号" width="120"></el-table-column>
					<el-table-column prop="vbeln" label="开票凭证" width="150"></el-table-column>
					<el-table-column prop="xblnr" label="参考凭证号" width="150"></el-table-column>
					<el-table-column prop="zfbdt" label="用于到期日计算的基准日期" width="150"></el-table-column>
					<el-table-column prop="shkzg" label="借方/贷方标识" width="80"></el-table-column>
					<el-table-column prop="cpudt" label="会计凭证输入日期" width="150"></el-table-column>
					<el-table-column prop="status" label="状态" width="100">
						<template slot-scope="scope" v-show="scope.row.status == '0'">
							<div v-if="scope.row.status == 0">
								未清
							</div>
							<div v-if="scope.row.status == 2">
								已清
							</div>
						</template>
					</el-table-column>
				</el-table>
                <!--		  客户信贷记录列表-->
                <el-table
                        v-show="tabIndex == '3'"
                        ref="multipleTable"
                        :data="tableData3"
                        stripe
                        style="width: 100%"
						:border="true"
						max-height="520"
                >
                    <el-table-column type="selection" width="55" label="全选"></el-table-column>
                    <el-table-column fixed type="index" label="#" width="40" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="id" label="信贷id" width="220" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="cid" label="信贷编码" width="220" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="currency" label="币种" width="70" ></el-table-column>
                    <el-table-column prop="quota" label="信贷余额" width="100" :show-overflow-tooltip="true">
						<template slot-scope="scope">
						    <div style="text-align: right;">
						        {{scope.row.quota}}
						    </div>
						</template>
					</el-table-column>
                    <el-table-column prop="maxquota" label="信贷总额" width="100" :show-overflow-tooltip="true">
						<template slot-scope="scope">
						    <div style="text-align: right;">
						        {{scope.row.maxquota}}
						    </div>
						</template>
					</el-table-column>
                    <el-table-column prop="validitydate" label="信贷有效期" min-width="160" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="isOverdue" label="是否逾期" min-width="100" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="is_overdue" :v="scope.row.isOverdue"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="paymentdate" label="信贷账期" min-width="160" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="status" label="审核状态" min-width="100" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="credit_status" :v="scope.row.status"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cuname" label="申报人" min-width="80" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="kkber" label="公司代码" min-width="90" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="creCategory" label="信贷类型" min-width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="cre_category" :v="scope.row.creCategory"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productId" label="专属信贷种类" min-width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="product_level" :v="scope.row.productId"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="300">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
								<el-button
								        v-show="scope.row.status == '3'||scope.row.status == '1'"
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="viewpress(scope.row.instid)"
								>跟踪
								</el-button>
								<el-button
								        v-show="scope.row.cuname == user || scope.row.status == '3'"
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="exitCredit(scope.row)"
								>撤销
								</el-button>
								<el-button
								        :disabled="scope.row.status == '3'"
								        v-show="scope.row.status != '2' && adminFlag"
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="seeDetail(scope.row)"
								>查看
								</el-button>
								<el-button
								        v-show="scope.row.status == '2'"
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="continueCreate(scope.row)"
								>
								    编辑
								</el-button>
								<el-button
								        v-auth="'haveTerminateButton'"
								        v-if="scope.row.status == 0"
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="terminateCredit(scope.row)"
								>作废
								</el-button>
								<el-button
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="downloadFile(scope.row)"
								>下载
								</el-button>
							</div>
                        </template>
                    </el-table-column>
                </el-table>
                <!--		  客户信贷sap对账详情-->
                <el-table
                        v-show="tabIndex == '4'"
                        ref="multipleTable"
                        :data="tableData4"
                        stripe
                        style="width: 100%"
                        :border="true"
                        max-height="520"
                >
                    <el-table-column type="selection" width="55" label="全选"></el-table-column>
                    <el-table-column fixed type="index" label="#" width="40" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="usercode" label="客户编码" width="120" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="username" label="客户名称" width="200" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="companyCode" label="公司编码" width="100" ></el-table-column>
                    <el-table-column prop="companyName" label="公司名称" width="150" ></el-table-column>
                    <el-table-column prop="time" label="时间" width="120" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="amount" label="月末余额" width="120" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.amount}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="120" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">未提交</span>
                            <span v-if="scope.row.status==1">已对账</span>
                            <span v-if="scope.row.status==2">驳回</span>
                            <span v-if="scope.row.status==3">审批中</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="250">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="downloadFileDz(scope.row)"
                                >下载PDF
                                </el-button>
                                <el-button
                                        v-if="scope.row.status != 3"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="contrastSapFile(scope.row)"
                                >上传
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="seeContrastSapFile(scope.row)"
                                >查看
                                </el-button>
                                <el-button
                                        v-if="scope.row.instid"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="viewpress(scope.row.instid)"
                                >跟踪
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <viewhistory
                        :visible.sync="showhistory"
                        v-if="showhistory"
                        :id="instid"
                />
                <div class="h-tableB h-mrt30">
					 <div class="h-tableBL" v-if="tabIndex == '2'">
					   <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="synSapHistory()">同步历史明细</el-button>
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="exportSapHistory()">导出历史明细</el-button>
					 </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="choose"/>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <el-dialog
                    :visible.sync="dialogFormVisible"
                    v-if="dialogFormVisible"
                    class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>下载附件</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;height:400px;overflow: scroll">
                    <brupload
                            :refid="creditRefid"
                            reftype="信贷管理-新增信贷"
                    />
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>上传附件</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
                    <el-form :inline="true" :model="contrastSapFileDate" class="demo-form-inline h-formBorder"
                             style="margin-top: 0.4rem">
                        <el-form-item label="上传附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
                            <brupload
                                    :refid="contrastSapid"
                                    reftype="信贷管理-对账信息"
                                    uploadflag
                                    delflag
                                    pdfFlag
                                    :showtime="false"
                            >
                            </brupload>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                    <el-button type="primary" @click="checkContrastSap()">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisiblechakan" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>查看附件</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
                    <el-form :inline="true" :model="contrastSapFileDate" class="demo-form-inline h-formBorder"
                             style="margin-top: 0.4rem">
                        <el-form-item label="附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
                            <brupload
                                    :refid="contrastSapid"
                                    reftype="信贷管理-对账信息"
                                    :tpFlag="true"
                                    :showtime="false"
                            >
                            </brupload>
                        </el-form-item>
                    </el-form>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
    import util from "../../../utils/util";
	import updownfile from '../../../utils/updownfile';
    import ss from '../../../api/SystemService';
    import supervisorDetailsService from "../../../api/loud/credit/supervisorDetailsService";
	import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import creditService from "../../../api/loud/credit/creditService";
    import http from "../../../utils/fetch";

    export default {
        data() {
            var validateNumber = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请填写必填项'));
                } else {
                    if (/^[0-9]+(\.?[0-9]+)?$/.test(this.dialogForm.maxquota)) {
                        callback();
                    } else {
                        callback(new Error('请输入数字或小数'));
                    }
                }
            };
            var validateTiaoPeiNumber = (rule, value, callback) => {
                console.log(this.queryCreditTiaoPei.maxquota, 'maxquota', this.quota, '不变的')
                if (this.queryCreditTiaoPei.maxquota == '') {
                    callback(new Error('请填写必填项'));
                } else {
                    if (!/^[0-9]+(\.?[0-9]+)?$/.test(this.queryCreditTiaoPei.maxquota)) {
                        callback(new Error('请输入数字'));
                    } else if (this.queryCreditTiaoPei.maxquota > this.quota) {
                        callback(new Error('超出可调配范围！'));
                    } else if (/^[0-9]+(\.?[0-9]+)?$/.test(this.queryCreditTiaoPei.maxquota)) {
                        callback();
                    }
                }
            };
            return {
				companyCode: this.$route.query.companyCode,
                creditRefid: '',
                dialogFormVisible: false,
                sapZxdSwylAccount: {},
				wxOrder: {},
                tableData4: [],
                creditId: '',
                creditId2: '',
                contrastSapid:'',
                checked: true,
                showOrhide: false,
                toshow: 'customerDetailss',
                status: 1,
                instid: '',
                showhistory: false,
                isShowTiaoPei: true,
                isShowSaveCredit: false,
                isShowCreateCredit: false,
                dialogFormVisible1:false,
                dialogFormVisiblechakan:false,
                refid: null,
                isShow: false,
                user:null,
                adminFlag:false,
                //当前客户信息
                data: {
                    username: ''
                },
                data2: {},
                newDialog: false,
                tabIndex: 1,
                zy: {
                    khmc: '',
                    xdzh: '',
                    hfkzfw: '',
                    bz: ''
                },
                contrastSapFileDate:{
				    id:null,
                    refid:null
                },
                dialogForm: {
                    username2: '',
                    id: null,
                    maxquota: null,
                    receDate: null,
                    isSign: '',
                    isOverdue: '',
                    signCompany: null,
                    cdate: null,
                    validitydate: null,
                    paymentdate: null,
                    kkber: null,
                    ctlpc: null,
                    creCategory: null,
                    productId: null,
                },
                formInline: {},
                //表单
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                rules1: {
                    maxquota: [
                        {required: true, validator: validateTiaoPeiNumber, trigger: 'change'},
                    ],
                    productId: [
                        {required: true, message: '请填写必填项', trigger: 'change'},
                    ],
                    kkber: [
                        {required: true, message: '请填写必填项', trigger: 'change'},
                    ],
                    creditId2: [
					    {required: true, message: '请填写必填项', trigger: 'change'},
					],
                },
                rules2: {
                    username2: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    maxquota: [
                        {required: true, validator: validateNumber, trigger: 'blur'},
                    ],
                    receDate: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    isSign: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    isOverdue: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    signCompany: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    paymentdate: [
                        {required: true, validator: validateNumber, trigger: 'blur'},
                    ],
                    validitydate: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    creCategory: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    productId: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    kkber: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    ctlpc: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                },
                //表格
                multipleSelection: [],
                tableData: [],
                tableData1: [],
                tableData2: [],
                tableData3: [],
                tableData4: [],
                domestic: {
                    receUsercode: null,
					BUKRS: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                foreign: {
                    remitterCode: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                ischeck: false,
                recordList: {
                    usercode: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                orderList: {
                    soldToCode: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                creditData: {
                    usercode: null,
                },
                contrastSap: {
                    usercode: null,
                    companyCode: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                tabflag: false,
                countrytype: null,
                moneyCash: {
                	usercode: null,
					kkber: null,
					},
                res: {},
                zxbCreditList: [],
                zsCreditList: [],
                value: '',
                value1: '',
                options: [],
                queryCreditTiaoPei: {
                    usercode: null,
                    kkber: null,
                    maxquota: '',
                    creCategory: null,
                    productId: null,
                },
                isSelfTiaoPei: false,
                quota: '',
                maxquota: '',
                tiaoPeiCreditVo: {
                    beforeTiaopei: {},
                    afterTiaopei: {},
                    isSelfTiaoPei: null,
                },
            };
        },
        created() {
            this.user=this._user.username;
            // 遮罩
            this.showzhezhao()
            //是否管理员权限
            this.adminFlag = this.$store.getters.hasRole('swyl_admin');
            //获取客户信息
            this.data.username = this.$route.query.username;
            console.log(this.$route.query, "this.$route.query")
            if (this.$route.query.usercode) {
                //主管通过页面跳转进入，获取当前选中查看详情的经销商信息，并查询对应信息
                this.countrytype = this.$route.query.countrytype;
                this.isShowCreateCredit = true;
                this.user = this.$route.query;
                this.dialogForm.username2 = this.user.username ? this.user.username : '';
                this.dialogForm.usercode = this.user.usercode;
                this.queryCreditTiaoPei.usercode = this.user.usercode;
                this.moneyCash.usercode = this.user.usercode;
                this.refid = this.user.usercode + '新增信贷临时refid';

                console.log(this.user, 'this.user')
                //查询回款详情
                this.query();
                this.getCredit();
                this.selectMoneyCash();
                this.isDailishang();
            } else {
                //获取当前登录用户信息，能到达这个页面的一定是经销商
                this.isShowTiaoPei = false;
                this.getUser();
            }
        },
        methods: {
			synSapHistory(){
				this.wxOrder.KUNNR = this.user.usercode;
				this.wxOrder.BUKRS = this.companyCode;
				customerLedgerService.synSapHistory(this.wxOrder).then(res => {
					if (res.f) {
						this.$message({
						    type: 'success',
						    message: '同步成功!'
						});
					}
				})
			},
			exportSapHistory(){
				this.wxOrder.KUNNR = this.user.usercode;
				this.wxOrder.BUKRS = this.companyCode;
				updownfile.down("/api/swyl/v1/chengben/sapzxdswylaccount/exportSapHistory",this.wxOrder);
			},
            isDailishang(){
                supervisorDetailsService.isDailishang().then(res => {
                    if (res){
                        this.isShowTiaoPei = false;
                    }
                })
            },
            clearCredit(v) {
                this.$confirm('是否确定清账此信贷?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supervisorDetailsService.clearCredit(v.id).then(res => {
                        if (res.f) {
                            this.$message({
                                type: 'success',
                                message: '清账成功!'
                            });
                            this.getUserAreaAndCreditList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            },
            downloadFile(v) {
                this.creditRefid = v.id;
                this.dialogFormVisible = true;

            },
            downloadFileDz(v) {
                creditService.printProductBook(v.id).then(rd => {
                    let link = document.createElement('a')
                    let blob = new Blob([rd],{type: 'application/pdf'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', v.usercode+'-'+v.companyCode+'-'+v.time+`-对账详情.pdf`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function(error) {
                    console.log(error)
                });

            },
            contrastSapFile(v){
                this.contrastSapid = this.$util.getUuid();
                this.contrastSapFileDate = v;
                this.contrastSapFileDate.refid = this.contrastSapid;
                this.dialogFormVisible1 = true;
            },
            seeContrastSapFile(v){
                this.contrastSapid = v.refid;
                this.dialogFormVisiblechakan = true;
            },
            //提交附件审批
            checkContrastSap(){
                creditService.submitCheckContrastFile(this.contrastSapFileDate).then(rd => {
                    if(rd.f){

                        this.$message({
                            type: 'success',
                            message: '提交成功!'
                        });
                        this.dialogFormVisible1 = false;
                        this.tabchange(4);
                    }
                })
            },
            terminateCredit(v) {
                this.$confirm('是否确定作废此信贷?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supervisorDetailsService.terminateCredit(v.id).then(response => {
                        if (response.f) {
                            this.$message({
                                type: 'success',
                                message: '作废成功!'
                            });
                            this.getUserAreaAndCreditList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消作废'
                    });
                });

            },
            exitCredit(v) {
                console.log(v);
                this.$confirm('撤回后将终止当前审批流程，是否确认撤回?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supervisorDetailsService.exitCredit(v.id).then(response => {
                        if (response.f) {
                            this.$message({
                                type: 'success',
                                message: '撤销成功!'
                            });

                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消撤销'
                    });
                });

            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextcustomer(i) {
                if (this.status == '1') {
                    this.status = 2;
                } else if (this.status == '2') {
                    this.status = 3;
                    document.documentElement.scrollTop = 300;
                } else if (this.status == '3') {
                    document.documentElement.scrollTop = 300;
                    this.status = 4;
                } else if (this.status == '4') {
                    this.status = 5;
                } else if (this.status == '5') {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            viewpress(v) {

                this.instid = v;
                this.showhistory = true;
            },
            tiaoPeiCredit(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.tiaoPeiCreditVo.beforeTiaopei = this.value;
                        if (this.isSelfTiaoPei) {
                            this.tiaoPeiCreditVo.isSelfTiaoPei = true;
                            this.tiaoPeiCreditVo.afterTiaopei = this.queryCreditTiaoPei;
                            this.tiaoPeiCreditVo.afterTiaopei.id = this.value.id;
                        } else {
                            this.tiaoPeiCreditVo.isSelfTiaoPei = false;
                            this.tiaoPeiCreditVo.afterTiaopei = this.queryCreditTiaoPei;
                            this.tiaoPeiCreditVo.afterTiaopei.id = this.value1.id;
                        }
                        console.log(this.value, 'value')
                        console.log(this.tiaoPeiCreditVo, 'after')
                        customerDetailsService.tiaoPeiCredit(this.tiaoPeiCreditVo).then(response => {
                            if (response.f) {
                                this.$message({
                                    type: "success",
                                    message: response.msg
                                });
								location.reload();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            chooseByCredit() {

                customerDetailsService.queryCredit(this.creditId2).then(response => {
                    debugger
                    this.value1 = response.obj;
                    // this.quota = this.value.quota;
                    // this.maxquota = this.value.maxquota;
                    // this.queryCreditTiaoPei.creCategory = this.value.creCategory;
                    // if (this.value.creCategory != '0') {
                    //     this.queryCreditTiaoPei.productId = null;
                    // }
                })

                this.queryCreditTiaoPei.maxquota = null;
            },
            isshowByTiaoPeiCredit() {
                if (this.value.creCategory != '0') {
                    if (!this.isSelfTiaoPei && this.queryCreditTiaoPei.kkber != null) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (!this.isSelfTiaoPei && this.queryCreditTiaoPei.kkber != null && this.queryCreditTiaoPei.productId != null && this.queryCreditTiaoPei.productId != '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            //查询可被调配的信贷列表
            queryByTiaoPeiCredit() {
                customerDetailsService.queryByTiaoPeiCredit(this.queryCreditTiaoPei).then(response => {
                    this.options = response;
                    this.value1 = '';
                })
            },
            //调配信贷额度方法
            changeCreditBalance() {
                this.value.quota = this.quota - this.queryCreditTiaoPei.maxquota
                this.value.maxquota = this.maxquota - this.queryCreditTiaoPei.maxquota
                // console.log(this.$refs.ref1.value,'aaaaaaaaaaaaaaaaa')
                //  var data = this.$refs.ref1.value
                //  if(data>this.value.quota){
                //  	return this.value.quota;
                //  }
            },
            chooseCredit() {
                customerDetailsService.queryCredit(this.creditId).then(response => {
                    this.value = response.obj;
                    this.quota = this.value.quota;
                    this.maxquota = this.value.maxquota;
                    this.queryCreditTiaoPei.creCategory = this.value.creCategory;
                    if (this.value.creCategory != '0') {
                        this.queryCreditTiaoPei.productId = null;
                    }
                })

            },
            //查询当前查询客户的余额、信贷、返利，渲染图饼
            selectMoneyCash() {
                if (this.$route.query.companyCode){
                    this.moneyCash.kkber = this.$route.query.companyCode;
                }else {
                    this.moneyCash.kkber = this.user.usercode;
                }
                customerDetailsService.selectMoneyCash(this.moneyCash).then(response => {
                    this.res = response;
                    this.lineChart1();
                    this.lineChart2();
                    this.lineChart3();
                })
            },
            //取消按钮
            exit() {
                this.isShow = false;
                this.newDialog = false;
            },
            //检索按钮功能
            checkData() {
                this.tabIndex = 0;
            },
            //编辑按钮功能
            continueCreate(v) {
                //加载此条信贷对应的上传附件
                this.refid = v.id;
                this.isShow = true;
                this.isShowSaveCredit = false;
                this.newDialog = true;
                this.dialogForm.id = v.id;
                this.dialogForm.maxquota = v.maxquota;
                this.dialogForm.receDate = v.receDate;
                this.dialogForm.isSign = v.isSign.toString();
                this.dialogForm.isOverdue = v.isOverdue.toString();
                this.dialogForm.signCompany = v.signCompany;
                this.dialogForm.cdate = v.cdate;
                this.dialogForm.validitydate = v.validitydate;
                this.dialogForm.paymentdate = v.paymentdate;
                this.dialogForm.kkber = v.kkber;
                this.dialogForm.ctlpc = v.ctlpc;
                this.dialogForm.creCategory = v.creCategory;
                this.dialogForm.productId = v.productId;
            },
            //查看详情按钮功能，根据tabIndex的不同，跳转到不同页面
            seeDetail(v) {
                console.log(this._user.username, "当前登录人");
                if (this.tabIndex == '1') {
                    this.$router.push({path: "/moneyBack_detail", query: v});
                } else if (this.tabIndex == '2') {
                    var id = v.id;
                    var instid = v.instid;
                    this.$router.push({path: "/dingdmain/orderNxshenpi?id=" + id + "&f=1&instid=" + instid + "&taskstatus=1"});
                } else if (this.tabIndex == '3') {
                    this.$router.push({path: "/customerOrder", query: v});
                }
            },
            //获取当前用户信贷记录，通过usercode查询基本信息
            getCredit() {
                this.creditData.usercode = this.user.usercode;
                this.queryRecord();
                this.queryTiaopeiCredit();
            },
            //获取当前登录用户信息
            getUser() {
                customerDetailsService.getUser().then(response => {
                    this.user = response.obj;
                    this.countrytype = response.obj.countrytype;
                    this.dialogForm.username2 = this.user.username ? this.user.username : '';
                    this.dialogForm.usercode = this.user.usercode;
                    this.moneyCash.usercode = this.user.usercode;
                    this.refid = this.user.usercode + '新增信贷临时refid';
                    //查询回款详情
                    this.query();
                    this.getCredit();
                    this.selectMoneyCash();
                })
            },
            //提交审核新增信贷信息
            commitCreate(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.isShow = false;
                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.receDate))) {
                            if (this.dialogForm.receDate != null) {
                                this.dialogForm.receDate = util.riQi3(this.dialogForm.receDate);
                            }
                        }
                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.cdate))) {
                            if (this.dialogForm.cdate != null) {
                                this.dialogForm.cdate = util.riQi3(this.dialogForm.cdate);
                            }
                        }
                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.validitydate))) {
                            if (this.dialogForm.validitydate != null) {
                                this.dialogForm.validitydate = util.riQi3(this.dialogForm.validitydate);
                            }
                        }
                        this.dialogForm.refidUserCode = this.user.usercode;
                        customerDetailsService.commitCreate(this.dialogForm).then(response => {
                            if (response.f) {
                                this.$message({
                                    type: "success",
                                    message: response.msg
                                });
                                this.queryRecord();
                                this.newDialog = false;
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.msg
                                });
                            }

                        })
                    } else {
                        return false;
                    }
                });
            },
            //暂存新增信贷信息
            saveCreate() {
                this.isShow = false;
                this.dialogForm.status = 2;
                this.dialogForm.usercode = this.user.usercode;
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.receDate))) {
                    if (this.dialogForm.receDate != null) {
                        this.dialogForm.receDate = util.riQi3(this.dialogForm.receDate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.cdate))) {
                    if (this.dialogForm.cdate != null) {
                        this.dialogForm.cdate = util.riQi3(this.dialogForm.cdate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.validitydate))) {
                    if (this.dialogForm.validitydate != null) {
                        this.dialogForm.validitydate = util.riQi3(this.dialogForm.validitydate);
                    }
                }
                this.dialogForm.refidUserCode = this.user.usercode;
                customerDetailsService.saveCreate(this.dialogForm).then(response => {
                    if (response.f) {
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                        this.newDialog = false;
                    }
                })
            },
            //新增信贷申请按钮功能
            createCredit() {
                this.$nextTick(() => {
                    this.dialogForm.maxquota = null;
                    this.dialogForm.receDate = null;
                    this.dialogForm.isSign = null;
                    this.dialogForm.isOverdue = null;
                    this.dialogForm.signCompany = null;
                    this.dialogForm.cdate = null;
                    this.dialogForm.validitydate = null;
                    this.dialogForm.paymentdate = null;
                    this.dialogForm.kkber = null;
                    this.dialogForm.ctlpc = null;
                    this.dialogForm.creCategory = null;
                    this.dialogForm.productId = null;
                    this.$refs["dialogForm"].resetFields();
                });
                this.isShowSaveCredit = true;
                this.newDialog = true;
                //加载上传插件
                this.refid = this.user.usercode + '新增信贷临时refid';
                this.isShow = true;
            },
            choose() {
                if (this.tabIndex == '0') {
                    this.checkData();
                } else if (this.tabIndex == '1') {
                    this.tabflag = false;
                    this.query();
                } else if (this.tabIndex == '2') {
                    this.tabflag = false;
                    this.queryOrder();
                } else if (this.tabIndex == '3') {
                    this.tabflag = false;
                    this.queryRecord();
                }else if (this.tabIndex == '4') {
                    this.tabflag = false;
                    this.queryContrastSap();
                }
            },
            //查询回款详情
            query() {
                if (this.countrytype == '1') {
                    if (this.tabflag) {
                        this.domestic.pageNo = 1;
                        this.domestic.pageSize = 10;
                    } else {
                        this.domestic.pageNo = this.q.pageNo;
                        this.domestic.pageSize = this.q.pageSize;
                    }
                    this.domestic.receUsercode = this.user.usercode;
					this.domestic.BUKRS = this.$route.query.companyCode;

                    customerDetailsService.query(this.domestic).then(response => {
                        this.tableData = response.records;
                        this.q.total = response.total;
                    })
                } else if (this.countrytype == '2') {
                    if (this.tabflag) {
                        this.foreign.pageNo = 1;
                        this.foreign.pageSize = 10;
                    } else {
                        this.foreign.pageNo = this.q.pageNo;
                        this.foreign.pageSize = this.q.pageSize;
                    }
                    this.foreign.remitterCode = this.user.usercode;

                    customerDetailsService.queryForeign(this.foreign).then(response => {
                        console.log('123123123--->', response.records)
                        this.tableData1 = response.records;

                        this.q.total = response.total;
                    })
                }

            },
            //查询信贷记录
            queryRecord() {
                this.tabflag = true;
                this.recordList.usercode = this.user.usercode;
                this.recordList.pageNo = this.q.pageNo;
                this.recordList.pageSize = this.q.pageSize;
                this.recordList.kkber = this.$route.query.companyCode;
                customerDetailsService.queryRecord(this.recordList).then(response => {
                    console.log(response, '信贷列表')
                    this.tableData3 = response.records;
                    this.q.total = response.total;
                })
            },
            queryTiaopeiCredit() {
                customerDetailsService.queryTiaopeiCredit(this.user.usercode).then(response => {
                    this.tableData4 = response;
                })
            },

            //查询客户明细账单数据
            queryOrder() {
                this.tabflag = true;
				this.q.KUNNR = this.user.usercode;
				this.q.BUKRS = this.companyCode;
				customerLedgerService.querySapAccount(this.q).then(response => {
					this.tableData2 = response.records;
					this.q.total = response.total;
				})
            },
            queryContrastSap(){
                this.tabflag = true;
                this.contrastSap.usercode = this.user.usercode;
                this.contrastSap.companyCode = this.companyCode;
                this.contrastSap.pageNo =  this.q.pageNo;
                customerDetailsService.getContrastSap(this.contrastSap).then(response => {
                    this.tableData4 = response.records;
                    this.q.total = response.total;
                })

            },
            tabchange(i) {
                this.tabIndex = i;
                if (this.tabIndex == '1') {
                    this.tabflag = true;
                    this.query();
                } else if (this.tabIndex == '3') {
                    this.tabflag = true;
                    this.queryRecord();
                } else if (this.tabIndex == '2') {
                    this.tabflag = true;
                    this.queryOrder();
                }else if (this.tabIndex == '4') {
                    this.tabflag = true;
                    this.queryContrastSap();
                }
            },
            lineChart1() {
                let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
                let option = {
                    title: {
                        text: '余额报表',
                        bottom: '27%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "7%",
                        data: ['信贷：￥' + this.res.creditBalance, '现金：￥' + this.res.cashBalance]
                    },
                    series: [{
                        name: '销售目标',
                        type: 'pie',
                        radius: '35%',
                        center: ['50%', '35%'],
                        data: [
                            {value: this.res.creditBalance, name: '信贷：￥' + this.res.creditBalance},
                            {value: this.res.cashBalance, name: '现金：￥' + this.res.cashBalance}
                        ],
                        label: {
                            normal: {
                                show: true,
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: 5,
                                length2: 5
                            }
                        },
                        hoverOffset: 10,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            color: function (params) {
                                //自定义颜色
                                var colorList = [
                                    '#afe6fd', '#5ba9fe'
                                ];
                                return colorList[params.dataIndex]
                            }
                        }
                    }]
                };
                lineChart1.setOption(option);
            },
            lineChart2() {
                let lineChart2 = this.$echarts.init(document.getElementById('h_lineChart2'));
                let option = {
                    title: {
                        text: '信贷报表',
                        bottom: '27%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "0%",
                        data: ['正常：' + this.res.isNotOverdue, '逾期预警：' + this.res.isGoingOverdue, '已逾期：' + this.res.isOverdue]
                    },
                    series: [{
                        name: '余额信贷',
                        type: 'pie',
                        radius: '35%',
                        center: ['50%', '35%'],
                        data: [
                            {value: this.res.isNotOverdue, name: '正常：' + this.res.isNotOverdue},
                            {value: this.res.isGoingOverdue, name: '逾期预警：' + this.res.isGoingOverdue},
                            {value: this.res.isOverdue, name: '已逾期：' + this.res.isOverdue}
                        ],
                        label: {
                            normal: {
                                show: true,
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: 5,
                                length2: 5
                            }
                        },
                        hoverOffset: 10,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            color: function (params) {
                                //自定义颜色
                                var colorList = [
                                    '#1c86ff', '#afe6fd', '#5ba9fe'
                                ];
                                return colorList[params.dataIndex]
                            }
                        }
                    }]
                };
                lineChart2.setOption(option);
            },
            lineChart3() {
                let lineChart3 = this.$echarts.init(document.getElementById('h_lineChart3'));
                let option = {
                    title: {
                        text: '返利报表',
                        bottom: '27%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "8%",
                        data: ['已兑：￥' + this.res.cashed, '未兑：￥' + this.res.tocash]
                    },
                    series: [
                        {
                            name: '返利图表',
                            type: 'pie',
                            radius: '35%',
                            center: ['50%', '35%'],
                            data: [
                                {value: this.res.cashed, name: '已兑：￥' + this.res.cashed},
                                {value: this.res.tocash, name: '未兑：￥' + this.res.tocash}
                            ],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    length: 5,
                                    length2: 5
                                }
                            },

                            hoverOffset: 10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color: function (params) {
                                    //自定义颜色
                                    var colorList = [
                                        '#afe6fd', '#5ba9fe'
                                    ];
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart3.setOption(option);
            },
        },
    };
</script>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .customers {
            position: absolute;
            z-index: 1;

        }

        .customer1 {
            top: 0.8rem;
            left: 0;
            width: 5.55rem;
            height: 11rem;
        }

        .customer2 {
            top: 2.8rem;
            right: 2rem;
            width: 12.95rem;
            height: 4rem;
        }

        .customer3 {
            width: 3rem;
            height: 0.8rem;
            left: 2.85rem;
            top: 4.95rem;
        }

        .customer4 {
            width: 3rem;
            height: 0.8rem;
            left: 5.4rem;
            top: 4.99rem;
        }

        .customer5 {
            width: 3rem;
            height: 1.5rem;
            right: 0.6rem;
            top: 6.17rem;
        }

        .customerbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }

    .outerCon {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #dae0f0;
        width: 100%;
        margin-bottom: 30px;

        .tabBtn {
            background-color: #f0f5fb;
            padding: 10px;
            border: 1px solid #dae0f0;
            margin-right: 10px;
            color: #282c2f;
            cursor: pointer;
        }

        .tabBtnAc {
            color: white;
            background-color: #2785e7;
        }
    }
</style>
<style>
	.h-formbLine .weekplandetail26 .h-elformWrap-2 {
		width: 33%;
	}

	.h-formbLine .weekplandetail26 .h-elformWrap-2 .el-form-item__label {
		width: 40%;
	}

	.h-formbLine .weekplandetail26 .h-elformWrap-2 .el-form-item__content {
		width: 60%;
	}
    .dialogout .h-formbLine .h-elformWrap-2 {
        width: 50% !important;
        padding-right: 0.2rem;
    }

    .dialogout .h-formbLine .el-form-item__label {
        font-size: 14px;
        line-height: normal;
        width: 49%;

    }

    .dialogout .h-formbLine .el-form-item__content {
        width: 51%;
    }
	/* .w-span .el-form-item__content span {
		display: inline-block;
		width: 100%;
		border-bottom: 1px solid #dedede;
	} */

</style>
